import Joi from 'joi-browser';
import isAddress from './utilities/ethereumAddress';
// actual validation logic

const etheremAddressJoi = Joi.extend(joi => ({
  base: joi.string().alphanum(),
  name: 'ethereumAddress',
  language: {
    valid: 'must be a valid etheruem address',
  },
  rules: [
    {
      name: 'valid',
      description: 'Valid Ethereum Address',
      validate(params, value, state, options) {
        if (!isAddress(value)) {
          return this.createError('ethereumAddress.valid', {}, state, options);
        }
        return value;
      },
    },
  ],
}));

// Rename ETH_ADDRESS to ETH_ADDRESS_SCHEMA?
const ETH_ADDRESS = etheremAddressJoi
  .ethereumAddress()
  .valid()
  .empty('');
const INTEGER = Joi.number()
  .integer()
  .empty('');
const POSITIVE_INTEGER = Joi.number()
  .integer()
  .positive()
  .empty('');
const ALPHA_NUMBER = Joi.string()
  .alphanum()
  .empty('');
const BOOLEAN = Joi.boolean();
const STRING = Joi.string().empty('');
const TICKER_SYMBOL = Joi.string()
  .regex(/^[a-zA-Z]{3,5}$/)
  .empty('')
  .options({
    language: {
      string: {
        regex: {
          base: 'must be a valid ticker symbol (3-5 letters, all uppercase)',
          name: 'must be a valid ticker symbol (3-5 letters, all uppercase)',
        },
      },
    },
  });
const DECIMAL_18_PRECISION = Joi.number()
  .precision(18)
  .empty('');

const INTEGER_FOR_TOKEN_DECIMAL = Joi.number()
  .integer()
  .min(0)
  .max(18);

const BIG_POSITIVE_INTEGER = Joi.string()
  .regex(/^[1-9]\d{0,36}$/)
  .empty('')
  .options({
    language: {
      string: {
        regex: {
          base: 'must be a positive integer',
          name: 'must be a positive integer',
        },
      },
    },
  });

export default {
  ETH_ADDRESS,
  INTEGER,
  POSITIVE_INTEGER,
  ALPHA_NUMBER,
  STRING,
  BOOLEAN,
  INTEGER_FOR_TOKEN_DECIMAL,
  TICKER_SYMBOL,
  DECIMAL_18_PRECISION,
  BIG_POSITIVE_INTEGER,
};



// WEBPACK FOOTER //
// ./src/validationTypes.js